import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-enrollment-submitted',
  templateUrl: './enrollment-submitted.component.html',
  styleUrls: ['./enrollment-submitted.component.scss']
})
export class EnrollmentSubmittedComponent {
  @Output() retry = new EventEmitter<void>();
  @Output() contactSupport = new EventEmitter<void>();
  @Output() nextModal = new EventEmitter<void>();
}